import React, {useRef, useState} from 'react'
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Paper, styled, TextField} from "@mui/material";
import ShowMessage from "../utils/show-message";
import useTimeout from "../utils/useTimeout";

const StyledPaper = styled(Paper)({
    textAlign: 'center',
    height: 50,
    backgroundColor: "rgb(255,255,224)",
    lineHeight: "50px",
})

/** Not yet implemented */
export default function OrganizationUserEditDialog(props) {
    const dialogRef = useRef(null);
    const title = props.title
    const user = props.user;

    const [msg, setMsg] = useState({});

    // form state
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [userType, setUserType] = useState("");

    const handleClose = () => {
        const dialogForm = dialogRef.current;
        if (firstName && lastName) {
            props.close(false)
        }
    };

    const handleCancel = () => {
        props.close(false);
    }

    const DialogAlert = () => {
        useTimeout(() => setMsg({}), 5000);
        return <ShowMessage msg={msg} />
    }

    const handleSubmit = (event) => {
        setLoading(true);
        event.preventDefault();

        const form = {}

        form["givenName"] = firstName;
        form["familyName"] = lastName;
        form["phone"] = phone;
    }


    return (
        <div>
            {msg && <DialogAlert/> }

            <Dialog open={props.open}
                    onClose={handleClose}
                    // ref={dialogRef}
                    // component="form"
                    // onSubmit={handleSubmit}
                    PaperProps={{style: {borderRadius: 12}}}
            >
                <DialogTitle color="white"
                             sx={{backgroundColor: "rgba(60,120,185,1)"}}>{title} User</DialogTitle>
                <DialogContent>
                    <TextField
                        required
                        sx={{mb: "10px", mt: "10px"}}
                        autoComplete="off"
                        id="firstName"
                        label="First Name"
                        fullWidth
                        variant="standard"
                        onChange={e => setFirstName(e.target.value)}
                    />
                    <TextField
                        required
                        sx={{mb: "10px"}}
                        autoComplete="off"
                        id="lastName"
                        label="Last Name"
                        fullWidth
                        variant="standard"
                        onChange={e => setLastName(e.target.value)}
                    />
                    <TextField
                        sx={{mb: "10px"}}
                        autoComplete="off"
                        id="phone"
                        label="Phone"
                        fullWidth
                        variant="standard"
                        onChange={e => setPhone(e.target.value)}
                    />

                    {user && user.userType === "admin" &&
                    <TextField
                        sx={{mb: "10px"}}
                        autoComplete="off"
                        id="userType"
                        label="User Type (admin / user)"
                        fullWidth
                        variant="standard"
                        />
                    }

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancel} variant="outlined">Cancel</Button>
                    <Button onClick={handleSubmit} variant="contained">Submit</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}